/* Sweet Reminders - shared product catalog (40 designs).
   handle -> {n:name, s:stone, i:image, c:category, col:swatch var,
              lede:product intro copy, sl:stoneline}
   Carries the per-product copy the static product pages had, which Shopify
   does not store. */
window.SR_CATALOG = {
"be-strong-no-matter-what-matte-jasper": {
"n": "Be Strong No Matter What",
"s": "Matte Jasper",
"i": "images/be-strong-no-matter-what-matte-jasper-0.jpg",
"c": "For Strength",
"col": "--coral-s",
"lede": "Some days strength looks like moving mountains. Other days it looks like simply getting up and trying again. This bracelet honors both.",
"sl": "matte jasper &middot; for strength"
},
"the-best-is-yet-to-come-sunstone": {
"n": "The Best Is Yet To Come",
"s": "Sunstone",
"i": "images/the-best-is-yet-to-come-sunstone-0.jpg",
"c": "For Comfort",
"col": "--butter-s",
"lede": "Whatever you have been through, whatever you are walking through right now — this bracelet is a reminder that your story is not finished yet.",
"sl": "sunstone &middot; for comfort"
},
"everything-i-am-you-helped-me-to-be-jade": {
"n": "Everything I Am, You Helped Me To Be",
"s": "Jade",
"i": "images/everything-i-am-you-helped-me-to-be-jade-0.jpg",
"c": "For Mom",
"col": "--mint-s",
"lede": "There are people in our lives who shape us so quietly and so deeply that we only fully understand their impact when we look back. This bracelet is for that person.",
"sl": "jade &middot; for mom"
},
"i-love-you-mom-pink-quartz": {
"n": "I Love You Mom",
"s": "Pink Quartz",
"i": "images/i-love-you-mom-pink-quartz-0.jpg",
"c": "For Mom",
"col": "--pink-s",
"lede": "Three words. A lifetime of meaning. This bracelet says what the heart already knows.",
"sl": "pink quartz &middot; for mom"
},
"love-you-more-pink-quartz": {
"n": "Love You More",
"s": "Pink Quartz",
"i": "images/love-you-more-pink-quartz-0.jpg",
"c": "For Mom",
"col": "--pink-s",
"lede": "It is the reply that never gets old. The three words that turn an ordinary moment into something unforgettable. This bracelet is for the love that always has a little more to give.",
"sl": "pink quartz &middot; for mom"
},
"live-in-the-moment-blue-angelite": {
"n": "Live In The Moment",
"s": "Blue Angelite",
"i": "images/live-in-the-moment-blue-angelite-0.jpg",
"c": "For Comfort",
"col": "--sky-s",
"lede": "Not yesterday. Not tomorrow. Right here. Right now. This bracelet is a gentle nudge to come back to the only moment that is truly yours.",
"sl": "blue angelite &middot; for comfort"
},
"love-you-more-each-day-rose-quartz": {
"n": "Love You More Each Day",
"s": "Rose Quartz",
"i": "images/love-you-more-each-day-rose-quartz-0.jpg",
"c": "For Love",
"col": "--pink-s",
"lede": "Sweet Reminders bracelets are designed to be worn close, carrying words that matter most throughout your day.",
"sl": "rose quartz &middot; for love"
},
"forever-in-my-heart-mother-of-pearl": {
"n": "Forever In My Heart",
"s": "Mother of Pearl",
"i": "images/forever-in-my-heart-mother-of-pearl-0.jpg",
"c": "For Love",
"col": "--lilac-s",
"lede": "Sweet Reminders bracelets are designed to be worn close, carrying words that matter most throughout your day.",
"sl": "mother of pearl &middot; for love"
},
"you-are-capable-of-amazing-things-sunstone": {
"n": "You Are Capable Of Amazing Things",
"s": "Sunstone",
"i": "images/you-are-capable-of-amazing-things-sunstone-0.jpg",
"c": "For Strength",
"col": "--butter-s",
"lede": "Sometimes you just need a reminder. Not from someone else. From yourself. This bracelet is that reminder.",
"sl": "sunstone &middot; for strength"
},
"nothing-is-impossible-citrine": {
"n": "Nothing Is Impossible",
"s": "Citrine",
"i": "images/nothing-is-impossible-citrine-0.jpg",
"c": "For Strength",
"col": "--butter-s",
"lede": "The Stone Paired with genuine citrine, a natural earth stone celebrated for its positivity, confidence, and motivating energy, this bracelet shines as brightly as its message. Citrine is known as a stone of optimism, clarity, and personal power, making it the perfect companion for anyone ready to believe in what is possible.",
"sl": "citrine &middot; for strength"
},
"fearless-matte-jasper": {
"n": "Fearless",
"s": "Matte Jasper",
"i": "images/fearless-matte-jasper-0.jpg",
"c": "For Strength",
"col": "--coral-s",
"lede": "Fear is loud. But courage is louder. This bracelet is a reminder of which one wins.",
"sl": "matte jasper &middot; for strength"
},
"don-t-let-the-hard-days-win-matte-jasper-copy": {
"n": "Be Strong And Courageous",
"s": "Blue Lapis",
"i": "images/don-t-let-the-hard-days-win-matte-jasper-copy-0.jpg",
"c": "For Strength",
"col": "--sky-s",
"lede": "Strength is not the absence of fear. It is the decision to keep going anyway. This bracelet is for everyone who keeps going.",
"sl": "blue lapis &middot; for strength"
},
"don-t-let-the-hard-days-win-matte-jasper": {
"n": "Don't Let The Hard Days Win",
"s": "Matte Jasper",
"i": "images/don-t-let-the-hard-days-win-matte-jasper-0.jpg",
"c": "For Strength",
"col": "--coral-s",
"lede": "Some days are just hard. There is no other word for it. This bracelet is for those days — a quiet reminder that hard is not forever and you are stronger than the moment you are in.",
"sl": "matte jasper &middot; for strength"
},
"always-forever-silver-champagne-crystal": {
"n": "Always And Forever",
"s": "Silver Champagne Crystal",
"i": "images/always-forever-silver-champagne-crystal-0.jpg",
"c": "For Love",
"col": "--lilac-s",
"lede": "Some promises do not need a grand gesture. They just need to be felt every single day. This bracelet is that promise.",
"sl": "silver champagne crystal &middot; for love"
},
"you-are-loved-more-than-you-know-rose-quartz": {
"n": "You Are Loved More Than You Know",
"s": "Rose Quartz",
"i": "images/you-are-loved-more-than-you-know-rose-quartz-0.jpg",
"c": "For Love",
"col": "--pink-s",
"lede": "Sometimes the people we love most need to hear it most. This bracelet says what words alone cannot always reach.",
"sl": "rose quartz &middot; for love"
},
"i-love-you-to-the-moon-and-back-silver-champagne-crystal": {
"n": "I Love You To The Moon And Back",
"s": "Silver Champagne Crystal",
"i": "images/i-love-you-to-the-moon-and-back-silver-champagne-crystal-0.jpg",
"c": "For Love",
"col": "--lilac-s",
"lede": "Some love is just bigger than words. It stretches past every limit, every mile, every moment. This bracelet is for that kind of love.",
"sl": "silver champagne crystal &middot; for love"
},
"your-light-never-fades-silver-champagne-crystal": {
"n": "Your Light Never Fades",
"s": "Silver Champagne Crystal",
"i": "images/your-light-never-fades-silver-champagne-crystal-0.jpg",
"c": "For Her Confidence",
"col": "--lilac-s",
"lede": "Some people leave a light behind when they go. It lives in memories, in the way they shaped you, in the moments you still feel them near. This bracelet is for that light.",
"sl": "silver champagne crystal &middot; for her light"
},
"you-are-stronger-than-you-think-bue-lapis": {
"n": "You Are Stronger Than You Think",
"s": "Blue Lapis",
"i": "images/you-are-stronger-than-you-think-bue-lapis-0.jpg",
"c": "For Strength",
"col": "--sky-s",
"lede": "You have already made it through every hard day you thought you could not survive. That is not luck. That is strength. This bracelet is a reminder of exactly that.",
"sl": "blue lapis &middot; for strength"
},
"believe-in-yourself-as-much-as-i-do-amazonite": {
"n": "Believe In Yourself As Much As I Do",
"s": "Amazonite",
"i": "images/believe-in-yourself-as-much-as-i-do-amazonite-0.jpg",
"c": "For Her Confidence",
"col": "--mint-s",
"lede": "There is someone in your life who sees you more clearly than you see yourself. Who knows what you are capable of before you do. This bracelet carries their voice with you every day.",
"sl": "amazonite &middot; for her light"
},
"be-your-own-kind-of-beautiful-amethyst": {
"n": "Be Your Own Kind Of Beautiful",
"s": "Amethyst",
"i": "images/be-your-own-kind-of-beautiful-amethyst-0.jpg",
"c": "For Her Confidence",
"col": "--lilac-s",
"lede": "There is only one you. And that is not a limitation. That is your greatest gift. This bracelet is a reminder to own it.",
"sl": "amethyst &middot; for her light"
},
"you-light-up-my-heart-citrine": {
"n": "You Light Up My Heart",
"s": "Citrine",
"i": "images/you-light-up-my-heart-citrine-0.jpg",
"c": "For Her Confidence",
"col": "--butter-s",
"lede": "Some people walk into a room and everything gets a little warmer. A little brighter. A little better. This bracelet is for that person.",
"sl": "citrine &middot; for her light"
},
"you-helped-me-grow-bamboo-agate": {
"n": "You Helped Me Grow",
"s": "Bamboo Agate",
"i": "images/you-helped-me-grow-bamboo-agate-0.jpg",
"c": "For Mom",
"col": "--coral-s",
"lede": "Growth does not happen alone. Behind every version of yourself you are proud of, there is someone who believed in you, guided you, and gave you room to become. This bracelet is for that person.",
"sl": "bamboo agate &middot; for mom"
},
"always-my-aunt-forever-my-friend-pink-jade-crystal": {
"n": "Always My Aunt Forever My Friend",
"s": "Pink Jade Crystal",
"i": "images/always-my-aunt-forever-my-friend-pink-jade-crystal-0.jpg",
"c": "For a Friend",
"col": "--pink-s",
"lede": "She is the one who shows up with love and no judgment. Who knows your whole story and loves you anyway. Who is family and friend all at once. This bracelet is for her.",
"sl": "pink jade crystal &middot; for a friend"
},
"side-by-side-no-matter-what-howlite-marble": {
"n": "Side By Side No Matter What",
"s": "Howlite Marble",
"i": "images/side-by-side-no-matter-what-howlite-marble-0.jpg",
"c": "For a Friend",
"col": "--sky-s",
"lede": "Not just on the good days. Not just when it is easy. Every day, every season, every hard and beautiful moment in between. This bracelet is a promise that never expires.",
"sl": "howlite marble &middot; for a friend"
},
"laugh-with-me-forever-pink-jade-crystal": {
"n": "Laugh With Me Forever",
"s": "Pink Jade Crystal",
"i": "images/laugh-with-me-forever-pink-jade-crystal-0.jpg",
"c": "For a Friend",
"col": "--pink-s",
"lede": "The best moments are not always the big ones. Sometimes they are just two people laughing until nothing else matters. This bracelet is for those moments and the person you share them with.",
"sl": "pink jade crystal &middot; for a friend"
},
"chosen-family-bamboo-agate": {
"n": "Chosen Family",
"s": "Bamboo Agate",
"i": "images/chosen-family-bamboo-agate-0.jpg",
"c": "For a Friend",
"col": "--coral-s",
"lede": "Not everyone who is family shares your blood. Some of the deepest bonds are the ones you build, the ones you choose, the ones that show up and stay. This bracelet is for those people.",
"sl": "bamboo agate &middot; for a friend"
},
"you-make-life-sweeter-sunstone": {
"n": "You Make Life Sweeter",
"s": "Sunstone",
"i": "images/you-make-life-sweeter-sunstone-0.jpg",
"c": "For Her Confidence",
"col": "--butter-s",
"lede": "Some people just make everything better. The ordinary days feel special. The hard days feel lighter. The good days feel golden. This bracelet is for that person.",
"sl": "sunstone &middot; for her light"
},
"through-every-season-amazonite": {
"n": "Through Every Season",
"s": "Amazonite",
"i": "images/through-every-season-amazonite-0.jpg",
"c": "For Comfort",
"col": "--mint-s",
"lede": "The best bonds do not just survive change. They grow through it. This bracelet is for the love and loyalty that stays constant no matter what season life brings.",
"sl": "amazonite &middot; for comfort"
},
"best-friends-always-forever-amazonite": {
"n": "Best Friends Always And Forever",
"s": "Amazonite",
"i": "images/best-friends-always-forever-amazonite-0.jpg",
"c": "For a Friend",
"col": "--mint-s",
"lede": "Real friendship is not measured in years. It is measured in moments, memories, and the kind of knowing that only comes from truly being seen. This bracelet is for that friendship.",
"sl": "amazonite &middot; for a friend"
},
"you-are-my-heart-s-calm-howlite-marble": {
"n": "You Are My Heart's Calm",
"s": "Howlite Marble",
"i": "images/you-are-my-heart-s-calm-howlite-marble-0.jpg",
"c": "For Comfort",
"col": "--sky-s",
"lede": "In a world that never stops moving, some people are your stillness. Your safe place. The quiet in the middle of everything loud. This bracelet is for that person.",
"sl": "howlite marble &middot; for comfort"
},
"i-carry-your-love-with-me-amethyst": {
"n": "I Carry Your Love With Me",
"s": "Amethyst",
"i": "images/i-carry-your-love-with-me-amethyst-0.jpg",
"c": "For Love",
"col": "--lilac-s",
"lede": "Distance cannot touch it. Time cannot dim it. Some love simply travels with you wherever you go, tucked quietly in your heart. This bracelet is a reminder of exactly that.",
"sl": "amethyst &middot; for love"
},
"your-love-shaped-me-amethyst": {
"n": "Your Love Shaped Me",
"s": "Amethyst",
"i": "images/your-love-shaped-me-amethyst-0.jpg",
"c": "For Mom",
"col": "--lilac-s",
"lede": "Some love does not just touch you. It shapes you. It lives in the way you see yourself, the strength you did not know you had, and the person you have grown into. This bracelet is for that love.",
"sl": "amethyst &middot; for mom"
},
"always-my-grandma-forever-my-friend-mother-of-pearl": {
"n": "Always My Grandma Forever My Friend",
"s": "Mother of Pearl",
"i": "images/always-my-grandma-forever-my-friend-mother-of-pearl-0.jpg",
"c": "For Mom",
"col": "--lilac-s",
"lede": "She is the keeper of the best stories. The maker of the warmest spaces. The one whose love feels like coming home no matter where you are. This bracelet is for her.",
"sl": "mother of pearl &middot; for mom"
},
"my-first-best-friend-rose-quartz": {
"n": "My First Best Friend",
"s": "Rose Quartz",
"i": "images/my-first-best-friend-rose-quartz-0.jpg",
"c": "For a Friend",
"col": "--pink-s",
"lede": "Before you knew what a best friend was, you already had one. The person who was there from the very beginning, who loved you before you even knew how to ask for it. This bracelet is for her.",
"sl": "rose quartz &middot; for a friend"
},
"home-is-where-you-are-jade": {
"n": "Home Is Where You Are",
"s": "Jade",
"i": "images/home-is-where-you-are-jade-0.jpg",
"c": "For Comfort",
"col": "--mint-s",
"lede": "Home is not always four walls and a familiar street. Sometimes home is a person. The one whose presence makes anywhere feel like exactly where you belong. This bracelet is for that person.",
"sl": "jade &middot; for comfort"
},
"thank-you-for-never-giving-up-amber-crystal": {
"n": "Thank You For Never Giving Up",
"s": "Amber Crystal",
"i": "images/thank-you-for-never-giving-up-amber-crystal-0.jpg",
"c": "For Mom",
"col": "--butter-s",
"lede": "Not everyone stays when things get hard. Not everyone keeps trying when it would be easier to walk away. This bracelet is for the ones who never did.",
"sl": "amber crystal &middot; for mom"
},
"love-you-more-than-words-mother-of-pearl": {
"n": "Love You More Than Words",
"s": "Mother of Pearl",
"i": "images/love-you-more-than-words-mother-of-pearl-0.jpg",
"c": "For Love",
"col": "--lilac-s",
"lede": "Some feelings are too big for words. They live in the quiet moments, the staying, the showing up, the love that does not need to announce itself because it is simply always there. This bracelet says what words alone never quite can.",
"sl": "mother of pearl &middot; for love"
},
"you-are-my-safe-place-pink-quartz": {
"n": "You Are My Safe Place",
"s": "Pink Quartz",
"i": "images/you-are-my-safe-place-pink-quartz-0.jpg",
"c": "For Comfort",
"col": "--pink-s",
"lede": "Everyone needs a place where they can breathe. Where they can be exactly who they are without explanation or apology. For some people that place is not somewhere you go. It is someone you have. This bracelet is for that someone.",
"sl": "pink quartz &middot; for comfort"
},
"my-heart-belongs-to-you-rose-quartz": {
"n": "My Heart Belongs To You",
"s": "Rose Quartz",
"i": "images/my-heart-belongs-to-you-rose-quartz-0.jpg",
"c": "For Love",
"col": "--pink-s",
"lede": "There are no conditions. No reservations. No holding back. Just a heart that is fully and completely yours. This bracelet is that declaration worn every single day.",
"sl": "rose quartz &middot; for love"
},
"always-my-mom-forever-my-friend-rose-quartz-1": {
"n": "Always My Mom Forever My Friend",
"s": "Rose Quartz",
"i": "images/always-my-mom-forever-my-friend-rose-quartz-1-0.jpg",
"c": "For Mom",
"col": "--pink-s",
"lede": "She was your first home. Your earliest comfort. The one who knew you before you knew yourself. And somewhere along the way she became something even more. This bracelet is for the mom who is also your forever friend.",
"sl": "rose quartz &middot; for mom"
}
};
